import { objectValues } from '@hsp/utilities';

import { Uri } from 'constants/uri';
import { IMutateExportShop } from 'types/api/audience';
import { OperationResult } from 'types/api/common';

import { BaseHttpService } from './http/base-http.service';

class ExportService extends BaseHttpService {
  constructor() {
    super({ endpoints: objectValues(Uri.Export) as string[] });
  }

  exportAudience(id: string, cancel = false): Promise<OperationResult> | undefined {
    const url = `${Uri.Export.Audience}/${id}`;

    return this.get(this.defaultRequestConfig(url, cancel));
  }

  exportShop({ shopId, ...params }: IMutateExportShop, cancel = false): Promise<OperationResult> | undefined {
    const url = `${Uri.Export.Shop}/${shopId}`;

    return this.post(params, this.defaultRequestConfig(url, cancel));
  }
}

export const exportService = new ExportService();
